import React from 'react';

const FormattedContent = ({ htmlContent, maxLines = 3, maxLength = 150 }) => {
  const stripHtml = (html) => {
    const tmp = document.createElement('div');
    tmp.innerHTML = html;
    return tmp.textContent || tmp.innerText || '';
  };
  
  const plainText = stripHtml(htmlContent);
  const truncatedText = plainText.length > maxLength 
    ? `${plainText.substring(0, maxLength)}...` 
    : plainText;

  return (
    <div 
      className="formatted-content"
      title={plainText} // Show full text on hover
      style={{
        display: '-webkit-box',
        WebkitLineClamp: maxLines,
        WebkitBoxOrient: 'vertical',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        maxHeight: `${maxLines * 1.5}em`, // Adjust based on line-height
        lineHeight: '1.5em'
      }}
    >
      {truncatedText}
    </div>
  );
};

export default FormattedContent;